export default {
    buttons: {
        end: '종료 및 결과 보기',
    },
    teacher: {
        tooltip: `
    <span class="tooltip_list">
        <strong>선생님과</strong>
        <span>선생님과 한 문제씩 진행해요</span>
     </span>
     <span class="tooltip_list">
        <strong>자기주도</strong>
        <span>학생이 전체 문제를 자기 속도로 풀어요</span>
    </span>            
    `,
    },
};
